export default function CsharpReadline() {
  return (
    <h2>Csharp ReadLine</h2>
  );
}
